<template>
  <div>
    <PCNavbar selectIndex="1" />
    <MobileNavBar :currentActive="0" />
    <CarouselHome :childArray="carouselImage" />
    <TodoShow :oneTitle="oneTitle" :twoTile="twoTile" />
    <div class="bottom_circle">
      <!-- <h1>产业大脑将会是所有城市园区产业发展的标准配置</h1> -->
      <div class="circle_img">
        <img :src="centerIImage[0]" alt="" class="hidden-xs-only" />
        <!-- <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-sm-and-up"/> -->
      </div>
      <div class="image-container">
        <div v-for="(image, index) in secondElements" :key="index" :span="8">
          <img
            :src="image.src"
            :alt="`Image ${index + 1}`"
            class="image"
            @click="gotoHand(image)"
          />
        </div>
      </div>
    </div>
    <CoreCompetence :thereTitle="thereTitle" />
    <!-- <CooperationCustomer/>
    <NewsInfomation/> -->
    <!-- <CallMe/> -->
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CarouselHome from "@/components/carousel_home/index";
import TodoShow from "@/components/todo_show/index";
import CoreCompetence from "@/components/core_competence/index";
// import CooperationCustomer from '@/components/cooperation_customer/index'
// import NewsInfomation from '@/components/news_infomation/index'
// import CallMe from '@/components/callme/index'
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  data() {
    return {
      subscribeImage: [], // 订阅图片数组
      centerIImage: [], // 中心图片数组
      financingImage: [], // 融资图片数组
      oneTitle: [], // 第一组标题

      thereTitle: [], // 第二组标题
      carouselImage: [], // 轮播图图片数组
      developImage: [], // 开发图片数组
      twoTile: [], // 第三组标题
      productCaseImage: [], // 产品案例图片数组
      buyerImage: [], // 买方画像图片数组
      firstElements: [], // 第一个元素数组
      secondElements: [], // 第二个元素数组
    };
  },
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CoreCompetence,
    // CooperationCustomer,
    // NewsInfomation,
    // CallMe,
    MobileCallme,
  },
  methods: {
    async storeUrlParams() {
      // 检查是否已有存储
      // 检查是否已有存储
      // localStorage.setItem('campaignParams', undefined);
      // const existing = localStorage.getItem('campaignParams');
      // if (existing) return;

      const queryParams = this.$route.query;

      const params = {};
      const keyMap = {
        utm_source: "utmSource",
        utm_medium: "utmMedium",
        utm_content: "utmContent",
        utm_id: "utmId",
      };

      Object.keys(keyMap).forEach((key) => {
        if (queryParams[key]) {
          params[keyMap[key]] = queryParams[key].replace(/ /g, "+");
        }
      });
      console.log(params);

      if (Object.keys(params).length) {
        localStorage.removeItem("campaignParams");
        localStorage.setItem("campaignParams", JSON.stringify(params));
        var campaignParams = localStorage.getItem("campaignParams");
        if (campaignParams != null) {
          const mb = JSON.parse(campaignParams);
          let obj = {
            ip: "",
            userId: "",
          };
          Object.assign(obj, mb);
          const token = localStorage.getItem("token");
          let config = {};
          if (token) {
            config = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };
          }
          const urlp = `https://www.hittik.com/znsystem/thirdparty/getClientIp`;
          // const urlp = `https://www.hittik.com/znsystem/thirdparty/getClientIp`;
          // 发起 GET 请求
          const response6 = await this.axios.get(urlp, config);
          if (response6) {
            console.log(response6, "response6");
          }

          const url ="https://www.hittik.com/znsystem/thirdparty/insertRecordAccess";
            // const url = "http://192.168.80.81:8080/znsystem/thirdparty/insertRecordAccess";
          this.axios.post(url, obj).then((response) => {
            if (response) {
              console.log(response, "6666");
            }
          });
          // this.$api.insertRecordAccess(obj).then((response) => {
          //         if (response) {
          //            console.log(response,'6666')

          //         }
          //       });
          console.log(mb, "123456");
          if ("utmId" in mb) {
            // let urls ="http://192.168.80.81:8080/znsystem/thirdparty/thirdpartyloginfree";
            let urls ="https://www.hittik.com/znsystem/thirdparty/thirdpartyloginfree";

            this.axios.post(urls, mb).then((response) => {
              if (response) {
                const token = response.data.data.access_token;
                const userId = response.data.data.userid;
                
                localStorage.setItem("token", token);
                localStorage.setItem("userId", userId);
                this.getuserinfor(userId)
                
                
              }
            });
          }
        }
      }
    },
    getuserinfor(userId){
       this.$api
          .getUserInfo({
            userId: userId,
          })
          .then((responses) => {
            if (responses) {
              console.log(responses)
              
                if(localStorage.getItem("phonedigits")){
                // console.log('111111')
              }else{
                setTimeout(() => {
                  window.location.reload()
                }, 500);

              }
              
              const userInfo = responses;
              localStorage.setItem(
                "phonedigits",
                userInfo.phonenumber.slice(-4)
              );

              this.$store.dispatch(
                "setPhoneLastDigits",
                userInfo.phonenumber.slice(-4)
              );
              
              
            }
          });
    },
    gotoHand(yuan) {
      switch (yuan.name) {
        case "1":
          this.$router.push("/home").catch((v) => {});
          break;
        case "productCaseImage":
          var token = localStorage.getItem("token");
          // console.log(token);

          if (token == null) {
            // this.$router.push("/home").catch((v) => {});
            this.$nextTick(() => {
              this.$store.commit("SET_LOGIN", true);
            });
          } else {
            this.$router.push("/production/1").catch((v) => {});
          }
          break;
        case "2-2":
          this.$router.push("/production/2").catch((v) => {});
          break;
        case "2-3":
          this.$router.push("/production/3").catch((v) => {});
          break;
        case "2-4":
          this.$router.push("/production/4").catch((v) => {});
          break;
        case "developImage":
          this.$router.push("/threenav").catch((v) => {});
          break;
        case "buyerImage":
          this.$router.push("/threenav").catch((v) => {});
          break;
        case "financingImage":
          this.$router.push("/threenav").catch((v) => {});
          break;
        case "4-3":
          this.$router.push("/fournav/3").catch((v) => {});
          break;
        case "subscribeImage":
          this.$router.push("/fivenav/1").catch((v) => {});
          break;
        case "5-2":
          this.$router.push("/fivenav/2").catch((v) => {});
          break;
        case "5-3":
          this.$router.push("/fivenav/3").catch((v) => {});
          break;
        case "5-4":
          this.$router.push("/fivenav/2").catch((v) => {});
          break;
        default:
          break;
      }
    },

    async getCardListData() {
      const token = localStorage.getItem("token");
      let config = {};
      if (token) {
        config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getTitle",
      //   config
      // );
      this.$api.getTitle().then((responses) => {
        if (responses) {
          //console.log(response.data);
          const newdata = responses;
          this.subscribeImage = this.extractUrls(newdata.subscribeImage);
          this.centerIImage = this.extractUrls(newdata.centerIImage);
          this.financingImage = this.extractUrls(newdata.financingImage);
          const newblob = newdata.carouselImage;
          this.carouselImage = newblob.map((link) => ({
            src: link,
          }));
          this.thereTitle = newdata.thereTitle;
          this.developImage = this.extractUrls(newdata.developImage);
          this.productCaseImage = this.extractUrls(newdata.productCaseImage);
          this.buyerImage = this.extractUrls(newdata.buyerImage);

          this.oneTitle = newdata.oneTitle;

          this.twoTile = newdata.twoTile;

          this.extractElements();
        }
      });
    },
    extractUrls(images) {
      return images.map((img) => {
        const urlMatch = img.match(/<url.*?>(.*?)<\/url>/);
        return urlMatch ? urlMatch[1].trim() : img;
      });
    },
    extractElements() {
      // 定义需要处理的数组字段
      const fields = [
        "subscribeImage",
        "developImage",
        "financingImage",
        "productCaseImage",
        "buyerImage",
      ];

      // 初始化存储结果的数组
      this.firstElements = [];
      this.secondElements = [];

      fields.forEach((field) => {
        const currentArray = this[field];
        if (currentArray.length > 0) {
          this.firstElements.push({
            name: field,
            src: currentArray[0],
          });
        }
        if (currentArray.length > 1) {
          this.secondElements.push({
            name: field,
            src: currentArray[1],
          });
        }
      });
    },
  },
  created() {
    console.log("token");
    this.storeUrlParams();
    this.getCardListData();
  },
};
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;

  // background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  // background-position: 0 0,110% 150%;
  // background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    img {
      width: 1264px;
      height: 410px;
    }
  }
  .image-container {
    display: flex;
    justify-content: center;
    margin-top: 0.52083vw;
    width: 1411px;
    flex-direction: row;
    margin-left: 252px;
    // gap: 10px;
    // padding: 10px;
  }

  .image {
    width: 242px;
    height: 108px;
    margin-right: 14px;
    border-radius: 10px;
    object-fit: cover;
    transition: transform 0.3s ease; /* 平滑放大效果 */
    cursor: pointer; /* 鼠标悬停时显示为手型 */
  }

  .image:hover {
    transform: scale(1.1); /* 鼠标悬停时放大图片 */
  }

  .el-card {
    width: 100%;
  }
}
</style>
